import { Group } from "./Group";
import { Model } from "./Model";
import { User } from "./User";

export interface GroupUser extends Model {
	group?: Group;
	groupId: number;
	user?: User;
	userId: number;
}

export class GroupUser implements GroupUser {
	groupId = -1;
	userId = -1;

	constructor(data?: Partial<GroupUser>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}